
import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {

	private authService = inject(AuthService);

	constructor() { }
	
	/**
	 * Este guard está diseñado específicamente para el login
	 * Hace logout de la plataforma cada vez que entramos
	 * @returns boolean
	 */
	canActivate(): boolean {
		this.authService.logout(false);
		return true;
	}
}
